<template>
  <div id="shop_control" class="maincont" style="padding-top: 15px;">
    <div class="ef--inner">
      <ul class="bottom-button" style="margin-top: 0px; margin-bottom: 20px;">
        <li class="bottom-button-item"><a href="javascript:void(0);" class="bt-gray" @click="onCancel">キャンセル</a></li>
        <li class="bottom-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onRegist">登録</a></li>
      </ul>
      <div class="fiscal-year">
        <div class="fiscal-year-caption">年度設定</div>
        <div class="fiscal-year-form">
          <span class="select-box">
            <select id="fiscal-year" name="fiscal-year" v-model="startMonth">
              <option value="1">1月</option>
              <option value="2">2月</option>
              <option value="3">3月</option>
              <option value="4">4月</option>
              <option value="5">5月</option>
              <option value="6">6月</option>
              <option value="7">7月</option>
              <option value="8">8月</option>
              <option value="9">9月</option>
              <option value="10">10月</option>
              <option value="11">11月</option>
              <option value="12">12月</option>
            </select>
          </span> ～ 12ヵ月
        </div>
      </div>
      <div class="fiscal-year">
        <div class="fiscal-year-caption">分析係数</div>
        <div>
          <input type="radio" id="one" value="1" v-model="useCoefficient">
          <label for="one">分析係数1</label>
          <br>
          <input type="radio" id="two" value="2" v-model="useCoefficient">
          <label for="two">分析係数2</label>
          <br>
          <input type="radio" id="three" value="3" v-model="useCoefficient">
          <label for="three">デマンド目標値</label>
        </div>
      </div>
    </div>
    <div class="ef--inner">
      <p class="intro-text">売り場面積や売上高などを任意で入力し事業所ごとの電力使用実績などを比較するときに使用します。</p>
      <div class="err_message">
        {{ errors.first("analysis_coefficient1") }}
      </div>
      <div class="err_message">
        {{ errors.first("analysis_coefficient2") }}
      </div>
    </div>
    <div class="ef--inner shop-control"><h2>事業所管理</h2>
      <div class="shop-control-container" style="height: 360px">
        <table class="shop-list" _fixedhead="rows:1;cols:0;">
          <thead>
            <tr>
              <th>お客さま名</th>
              <th>分析係数（１）※</th>
              <th>分析係数（２）※</th>
              <th>検針データ入力</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in coefficientList" v-bind:key="index">
              <td><a href="javascript:void(0);" @click="onDetail(item.account)">{{ item.name }}さま</a></td>
              <td>
                <input type="number"
                 class="input-field analytical-coefficient"
                 name="analysis_coefficient1"
                 data-vv-as="分析係数（１）"
                 :style="getStyle(item.analysis_coefficient1)"
                 v-model="item.analysis_coefficient1"
                 v-validate="'min_value:0.00|max_value:99999999.99'">
              </td>
              <td>
                <input type="number" class="input-field analytical-coefficient" name="analysis_coefficient2" data-vv-as="分析係数（２）" :style="getStyle(item.analysis_coefficient2)" v-model="item.analysis_coefficient2" v-validate="'min_value:0.00|max_value:99999999.99'">
              </td>
              <td><a href="javascript:void(0);" @click="onMeterData(item.account, item.name)"><img src="/assets/images/activity/icon.detail.png" /></a></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="table-note">※空欄でも可。半角数字と半角ピリオドのみ入力可。</p>
    </div>
    <meter-dialog
      @close="showModalMeter=false"
      v-if="showModalMeter"
      :account="this.modalAccount"
      :name="this.modalName"
    ></meter-dialog>
    <LoadExternalJS :url="fixedMidashiUrl"></LoadExternalJS>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Store from "../../store";
import MeterDialog from "../../components/MeterDialog";
import LoadExternalJS from "../../components/LoadExternalJS";

export default {
  name: "shop-control",
  components: {
    MeterDialog,
    LoadExternalJS
  },
  data: function() {
    return {
      coefficientList: [],
      startMonth: 4,
      useCoefficient: 1,
      showModalMeter: false,
      modalAccount: "",
      modalName: "",
      fixedMidashiUrl: "./assets/js/fixed_midashi.js"
    };
  },
  updated: function() {
    window.FixedMidashi.remove();
    window.FixedMidashi.create();
  },
  created: function() {
    console.log("created");
    this.getData();
  },
  methods: {
    getData: function() {
      console.log("getData");
      this.$axios
        .get(`/srv/api/chain_management/${Store.state.parentID}`, {
          withCredentials: true
        })
        .then(response => {
          console.log("chain_management success");
          console.log(response.data);
          if (typeof response.data == "object") {
            this.startMonth = response.data.start_month;
            this.useCoefficient = response.data.type;
            this.coefficientList = response.data.chain;
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log("chain_management error");
          console.log(error);
        });
    },
    setData: function() {
      console.log("setData");
      this.$validator.validateAll().then(result => {
        if (result) {
          const param = {
            start_month: this.startMonth,
            type: this.useCoefficient,
            chain: this.coefficientList
          };

          this.$axios
            .put(`/srv/api/chain_management/${Store.state.parentID}`, param, {
              withCredentials: true
            })
            .then(response => {
              console.log(response.data);
              if (response.data.status == "failure") {
                console.warn("chain_management failure");
                alert("登録できませんでした。");
              } else {
                console.log("OK");
                //alert("登録しました。");
              }
            })
            .catch(error => {
              console.log(error);
              alert("登録できませんでした");
            });
        } else {
          alert("エラー内容を確認してください。");
        }
      });
    },
    onRegist: function() {
      const ans = confirm('設定を変更しますか？');
      if (ans) {
        this.setData();
      }
    },
    onCancel: function() {
      const ans = confirm('キャンセルしますか？');
      if (ans) {
        this.getData();
      }
    },
    onDetail: function(account) {
      console.log(account);
      this.$store.dispatch("setConfirm", { isConfirmed: true });
      this.$store.dispatch("setChildID", account);
      let route = this.$router.resolve({path: '/'});
      window.open(route.href, '_blank');
    },
    onMeterData: function(account, name) {
      console.log(account);
      this.modalAccount = account;
      this.modalName = name;
      this.showModalMeter = true;
    },
    getStyle: function(value) {
      const num = Number(value);
      if (!isNaN(num) && (num > 99999999.99 || num < 0)) {
        return "background-color: #f00";
      }
      return "";
    }
  },
}
</script>